import { createSlice } from "@reduxjs/toolkit";
import {
  createOrderFromRateContract,
  createRateContract,
  getAllRateContract,
  getRateContractById,
  getRateContractPagination,
} from "../api/rateContract";

interface UsersState {
  loading: boolean;
  currentrateContractId: undefined | string;
  userData: any;
  error: any;
}

const initialState = {
  loading: false,
  currentrateContractId: undefined,
  userData: null,
  error: null,
} as UsersState;

export const rateContractSlice = createSlice({
  name: "rateContract",
  initialState,
  reducers: {
    resetrateContract: () => initialState,
  },
  extraReducers(builder) {
    builder
      .addCase(createRateContract.pending, (state, action) => {
        state.loading = true;
        state.currentrateContractId = action.meta.requestId;
      })
      .addCase(createRateContract.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
        }
      })
      .addCase(createRateContract.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
          state.error = action.error;
        }
      })
      .addCase(getRateContractById.pending, (state, action) => {
        state.loading = true;
        state.currentrateContractId = action.meta.requestId;
      })
      .addCase(getRateContractById.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
        }
      })
      .addCase(getRateContractById.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
          state.error = action.error;
        }
      })
      .addCase(getAllRateContract.pending, (state, action) => {
        state.loading = true;
        state.currentrateContractId = action.meta.requestId;
      })
      .addCase(getAllRateContract.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
        }
      })
      .addCase(getAllRateContract.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
          state.error = action.error;
        }
      })
      .addCase(createOrderFromRateContract.pending, (state, action) => {
        state.loading = true;
        state.currentrateContractId = action.meta.requestId;
      })
      .addCase(createOrderFromRateContract.fulfilled, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
        }
      })
      .addCase(createOrderFromRateContract.rejected, (state, action) => {
        const { requestId } = action.meta;
        if (state.loading && state.currentrateContractId === requestId) {
          state.loading = false;
          state.currentrateContractId = undefined;
          state.error = action.error;
        }
      });
  },
});

export const { resetrateContract } = rateContractSlice.actions;

export default rateContractSlice.reducer;
